import { useEffect, useState } from 'react';
import { Box, Button, DialogTitle, Modal, ModalDialog, Typography } from '@mui/joy';

interface DraftGuardCopy {
  title?: string;
  description?: string;
  discardLabel?: string;
}

export function useDraftGuard(dirty: boolean, busy = false, copy: DraftGuardCopy = {}) {
  const [leave, setLeave] = useState<(() => void) | null>(null);
  useEffect(() => {
    if (!dirty) return;
    const warn = (event: BeforeUnloadEvent) => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
  return {
    request: (action: () => void) => { if (!busy) { if (dirty) setLeave(() => action); else action(); } },
    dialog: <Modal open={!!leave} onClose={() => setLeave(null)}>
      <ModalDialog role="alertdialog" aria-labelledby="crm-discard-title" sx={{ maxWidth: 'calc(100vw - 32px)' }}>
        <DialogTitle id="crm-discard-title">{copy.title ?? 'Discard unsaved draft?'}</DialogTitle>
        <Typography>{copy.description ?? 'Your changes have not been saved. Keep editing to finish them.'}</Typography>
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button variant="outlined" onClick={() => setLeave(null)}>Keep editing</Button>
          <Button color="danger" onClick={() => { const action = leave; setLeave(null); action?.(); }}>{copy.discardLabel ?? 'Discard draft'}</Button>
        </Box>
      </ModalDialog>
    </Modal>,
  };
}
